import StyledDialog from "../../../../../components/StyledDialog";
import { DisclosureHost } from "../../../../../hooks/use-disclosure";
import { ScreeningFullViewForm } from "../../public-view/assessments/form/ScreeningFullViewForm";

interface PatientAssessmentFormModalProps {
  disclosureHost: DisclosureHost;
}

const PatientAssessmentFormModal = ({
  disclosureHost,
}: PatientAssessmentFormModalProps) => {
  const { opened, data, close } = disclosureHost;

  if (!opened) return null;

  return (
    <StyledDialog
      open={opened}
      onClose={close}
      dialogTitle="Assessment Form"
      maxWidth="md"
      fullWidth
    >
      <ScreeningFullViewForm
        activeTab={{ ind: 0, val: data?.assessmentType ?? "" }}
        assessmentTabs={
          data?.assessmentType ? [data.assessmentType] : undefined
        }
        onSave={() => {
          close();
        }}
        onSkip={() => {}}
        isPublicView
        actionId={data?.actionId}
        appointmentId={data?.appointmentId}
        patientId={data?.patientId}
      />
    </StyledDialog>
  );
};

export default PatientAssessmentFormModal;
